<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">{{ settings[selected].title }}</a>
      </label>
    </div>

    <div class="item nowrap">
      <span class="btn-container top-button-container">

        <button class="btn btn-white vertical align-items-center" routerLink="/custom/sales/nuovo">
          Aggiungi<i class="ml-10 fas fa-plus"></i>
        </button>

        <button class="btn btn-white vertical align-items-center" (click)="export()">
          Esporta<i class="ml-10 fas fa-file-excel"></i>
        </button>

        <button class="btn btn-white vertical align-items-center" routerLink="/sales/payments">
          pagamenti delle vendite <i class="ml-10 fas fa-euro-sign"></i>
        </button>

        <ng-template [ngIf]="selected == 'active'">
          <button class="btn vertical align-items-center" routerLink="/all/vendita/storico">
            Storico<i class="ml-10 far fa-folder"></i>
          </button>
        </ng-template>

        <ng-template [ngIf]="selected == 'inactive'">
          <button class="btn vertical align-items-center" [routerLink]="['../']" [queryParams]="{navigation: 'back'}">
            <i class="ml-10 fas fa-arrow-left has-margin-right"></i>Ritorna a Vendite 
          </button>
        </ng-template>
      </span>
    </div>

    <hr class="gold-hr">

    <section class="main-content wrapper scroll-delivery">
      <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
      <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
          <form  class="table-row-container row first-row filter" [formGroup]="allSaleForm" (ngSubmit)="filter()" *ngIf="allSaleForm">

              <div class="item data-col-5">
                <h4 class="title">PLATFORM</h4>
                <span class="data">
                  <select formControlName="platform" style="width: 120px;">
                    <option value="">Tutti</option>
                    <option value="shopifysale">Deluxy</option>
                    <!-- <option value="customsale">Custom</option> -->
                    <option value="cakesales">Cakes</option>
                    <option value="flowerssales">Flowers</option>
                    <option value="businesssales">Business</option>
                    <option value="deluxyexperiencesales">Deluxy Experience</option>
                    <option value="deluxydotcomsales">Deluxy Dot Com</option>
                  </select>
                </span>
              </div>

              <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('id')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('id')"></i>
                    SYSTEM ID
                  </h4>
                  <span class="data">
                    <input type="number" min="1000" max="10000" formControlName="id">
                  </span>
              </div>

              <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('actualOrderId')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('actualOrderId')"></i>
                    ID ordine effettivo
                  </h4>
                  <span class="data">
                    <input type="number" min="1000" max="10000" formControlName="actualOrderId">
                  </span>
              </div>

              <div class="item data-col-5">
                  <h4 class="title" (click)="navigateOrder('orderId')"> 
                    <i class="sort-icon fas" [ngClass]="orderIcon('orderId')"></i>
                    Ordine
                  </h4>
                  <span class="data">
                    <input type="number" min="1000" max="10000" formControlName="orderId">
                  </span>
              </div>

              <div class="item data-col-5" *ngIf="selected != 'active'">
                <h4 class="title">Conferma tipo</h4>
                <span class="data">
                  <select formControlName="confirmedBy" style="width: 120px;">
                    <option value="">Tutti</option>
                    <option value="Partner">Automatic</option>
                    <option value="Admin">Admin</option>
                  </select>
                </span>
              </div>

              <div class="item data-col-10 item" *ngIf="selected == 'inactive'">
                <h4 class="title" (click)="navigateOrder('deliveryDate')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('deliveryDate')"></i>
                  ORDINE DATA
                </h4>
                <span class="data">
                  <div class="date">Da:</div>
                  <input class="date" type="date" formControlName="deliveryDate_from">
                </span>
                <span class="data">
                  <div class="date">A: </div>
                  <input class="date" type="date" formControlName="deliveryDate_to">
                </span>
              </div>

              <div class="item data-col-10 item">
                <h4 class="title" (click)="navigateOrder('deliveryDate')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('deliveryDate')"></i>
                  DATA
                </h4>
                <span class="data">
                  <div class="date">Da:</div>
                  <input class="date" type="date" formControlName="deliveryDate_from">
                </span>
                <span class="data">
                  <div class="date">A: </div>
                  <input class="date" type="date" formControlName="deliveryDate_to">
                </span>
              </div>

              <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('orderId')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('orderId')"></i>
                    Cliente
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="orderId">  
                  </span>
              </div>

              <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('address')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('address')"></i>
                    Indirizzo
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="address">  
                  </span>
              </div>

              <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('phone')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('phone')"></i>
                    Telefono
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="phone">  
                  </span>
              </div>

              <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('channel')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('channel')"></i>
                    Canale
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="channel">  
                  </span>
              </div>

              <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('total')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('total')"></i>
                    Totale
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="total">  
                  </span>
              </div>

              <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('total')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('total')"></i>
                    COSTO CONSEGNA
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="totalDeliveryCost">  
                  </span>
              </div>

              <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('paymentStatus')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('paymentStatus')"></i>
                    Stato del pagamento
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="paymentStatus">  
                  </span>
              </div>

              <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('fullFillmentStatus')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('fullFillmentStatus')"></i>
                    Stato di adempimento
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="fullFillmentStatus">  
                  </span>
              </div>

              <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('orderId')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('orderId')"></i>
                    Elementi
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="orderId">  
                  </span>
              </div>

              <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('orderId')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('orderId')"></i>
                    SKU
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="orderId">
                  </span>
              </div>

              <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('deliveryMethod')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('deliveryMethod')"></i>
                    metodo di consegna
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="deliveryMethod">  
                  </span>
              </div>

              <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('vendor')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('vendor')"></i>
                    Vendor
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="vendor">
                  </span>
              </div>

              <div class="item data-col-10">
                  <h4 class="title" (click)="navigateOrder('status')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('status')"></i>
                    Stato
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="status">  
                  </span>
              </div>

              <div class="item nowrap">
                <h4 class="title hide-on-mobile">AZIONI</h4>
                <span class="data-row-left btn-container btn-container-actions">
                  <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                    RICERCA <i class="fas fa-search"></i></button>
                    <br/>
                  <button class="btn vertical align-items-center" (click)="resetFilter();">
                    RESET <i class="fas fa-times-circle"></i></button>
                </span>
              </div>
          </form>

          <div class="table-row-container row" *ngFor="let order of orders">

            <div class="item data-col-5">
              <h4 class="title">
                PLATFORM
              </h4>
              <div class="data data-id">
                <div>
                  <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                    {{
                      order?.platform?.toLowerCase() === 'businesssales' ? "BUSINESS" :
                      order?.platform?.toLowerCase() === 'shopifysale' ? "DELUXY" :
                      order?.platform?.toLowerCase() === 'flowerssales' ? "FLOWERS" :
                      order?.platform?.toLowerCase() === 'customsale' ? "CUSTOMSALE" :
                      order?.platform?.toLowerCase() === 'cakesales' ? "CAKE" : 
                      order?.platform?.toLowerCase() === 'deluxyexperiencesales' ? "DELUXY EXPERIENCE" :
                      order?.platform?.toLowerCase() === 'deluxydotcomsales' ? "DELUXY DOT COM" :
                      "---"
                    }}
                  </a>
                </div>
              </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                  SYSTEM ID :
                </h4>
                <div class="data data-id">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      #{{ order.id || "---" }}
                    </a>
                  </div>
                </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                  ID ordine effettivo :
                </h4>
                <div class="data data-id">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      {{ order.actualOrderId ? "#"+order.actualOrderId : "---" }}
                    </a>
                  </div>
                </div>
            </div>

            <div class="item data-col-5">
                <h4 class="title">
                  Ordine
                </h4>
                <div class="data data-id">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      {{ order.orderId ? "#"+order.orderId : "---" }}
                    </a>
                  </div>
                </div>
            </div>

            <div class="item data-col-10" *ngIf="selected != 'active'">
                <h4 class="title">
                  Conferma tipo
                </h4>
                <div class="data data-id">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale" *ngIf="selected == 'inactive'">
                      {{ showWhoConfirm(order) }}
                    </a>
                  </div>
                </div>
            </div>

            <div class="item data-col-10" *ngIf="selected == 'inactive'">
                <h4 class="title">
                  ORDINE DATA :
                </h4>
                <div class="data">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      <!-- {{ order.createdAt | date:'MMMM d, y - h:mm a' }} -->
                      {{ order.createdAt | date:'MMMM d, y' }}
                    </a>
                  </div>
                </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                  Data :
                </h4>
                <div class="data">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      <!-- {{ ((order.deliveryDate) || "---") + ' at ' + ((order.deliveryTime) || "---") }} -->
                      {{ order.deliveryDate && isValidDate(order.deliveryDate) ? (order.deliveryDate | date:'MMMM d, y') : 'N/A' }} 
                      {{ order.deliveryTime ? ' ' + order.deliveryTime : '' }}
                    </a>
                  </div>
                </div>
            </div>

            <div class="item data-col-5">
                <h4 class="title">
                  Cliente :
                </h4>
                <div class="data">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      {{ ( (order.firstName || '-')  + ' ' + (order.lastName || '-')) }}
                    </a>
                  </div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  Indirizzo
                </h4>
                <div class="data">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      {{ ( order.address || "---") }}
                    </a>
                  </div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  Telefono
                </h4>
                <div class="data">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      {{ ( order.phone || "---") }}
                    </a>
                  </div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  Canale
                </h4>
                <div class="data">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      {{ ( order.channel || "---") }}
                    </a>
                  </div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  Totale
                </h4>
                <div class="data">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      {{ ( order.total || "---") }}
                    </a>
                  </div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  COSTO CONSEGNA
                </h4>
                <div class="data">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      {{ showDeliveryPrice(order) | currency:'EUR' }}
                    </a>
                  </div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  Stato del pagamento
                </h4>
                <div class="data">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      {{ ( order.paymentStatus || "---") }}
                    </a>
                  </div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  Stato di adempimento
                </h4>
                <div class="data">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      {{ order.fullFillmentStatus || "Unfullfilled" }}
                    </a>
                  </div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  Elementi
                </h4>
                <div class="data">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      {{ myjson.parse(order.lineItems) | arrayJoin:', ':'name' }}
                    </a>
                  </div>
                </div>
            </div>

            <div class="item data-col-5">
                <h4 class="title">
                  SKU
                </h4>
                <div class="data">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      {{ myjson.parse(order.lineItems) | arrayJoin:', ':'sku' }}
                    </a>
                  </div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  metodo di consegna
                </h4>
                <div class="data">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      {{ order.deliveryMethod || "---" }}
                    </a>
                  </div>
                </div>
            </div>
            
            <div class="item data-col-5">
                <h4 class="title">
                  Vendor
                </h4>
                <div class="data">
                  <div>
                    <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                      {{ order.vendor || "---" }}
                    </a>
                  </div>
                </div>
            </div>
            
            <div class="item data-col-5">
              <h4 class="title">Stato</h4>

              <a
                (click)="$event.preventDefault(); openInNewTab(order.id, order)"
                class="redirect-sale"
              >
                {{ getOrderLabel(order, selected) }}
              </a>
            </div>

            <!--
            <div class="item data-col-5">
                <h4 class="title">
                  Stato
                </h4>
                <ng-template [ngIf]="selected == 'active'">
                  <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                    {{
                      (order?.status?.toLowerCase() === 'new' ||
                      (order?.status?.toLowerCase() === 'notaccepted' && order?.saleType?.toLowerCase() !== 'unique') ||
                      order?.status?.toLowerCase() === 'refused') ? 'Da Gestire' :

                      (order?.status?.toLowerCase() === 'confirmed' && order?.confirmedBy?.toLowerCase() === 'partner') ? 'Vendita Accettata' :

                      (order?.status?.toLowerCase() === 'confirmed' && (!order?.confirmedBy || order?.confirmedBy?.toLowerCase() === 'admin')) ? 'Vendita Confermata' :

                      (order?.status?.toLowerCase() === 'emailed' && order?.saleType?.toLowerCase() === 'nonunique') ? 'Vendita Inviata a ' + (order?.assignedPartner || '') :

                      ((order?.status?.toLowerCase() === 'emailed' || order?.status?.toLowerCase() === 'notaccepted') && order?.saleType?.toLowerCase() === 'unique') ? 'Inserita, Da Accettare' :

                      '--'
                    }}

                  </a>
                </ng-template>
                <ng-template [ngIf]="selected == 'inactive'">
                  <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                    {{
                      order?.status?.toLowerCase() === 'new' ? 'Da Gestire' :
                      (order?.status?.toLowerCase() === 'confirmed' && order?.confirmedBy?.toLowerCase() === 'partner') ? 'Vendita Accettata' :
                      (order?.status?.toLowerCase() === 'confirmed' && (!order?.confirmedBy || order?.confirmedBy?.toLowerCase() === 'admin')) ? 'Vendita Confermata' :
                      order?.status?.toLowerCase() === 'refused' ? 'Vendita Rifiutata' :
                      order?.status?.toLowerCase() === 'notaccepted' ? 'Non accettato' :
                      order?.status?.toLowerCase() === 'emailed' ? 'Vendita Inviata' :
                      '--'
                    }}
                  </a>
                </ng-template>
            </div>
            -->

            <div class="item nowrap">
                <span class="data-row-left btn-container btn-container-actions">
                    <button class="btn hvr-grow has-margin-right" (click)="$event.preventDefault(); generateLink(order);">
                      <ng-container *ngIf="!isLoading">
                        Generate Link&nbsp;<i class="ml-10 fas fa-link"></i>
                      </ng-container>
                      <ng-container *ngIf="isLoading">
                        Generating...&nbsp;<i class="fas fa-spinner fa-spin"></i>
                      </ng-container>
                    </button>

                    <button class="btn hvr-grow has-margin-right" (click)="$event.preventDefault(); sendEmailToCustomer(order)">
                      <ng-container *ngIf="!isLoading">
                        Send Email&nbsp;<i class="ml-10 fas fa-link"></i>
                      </ng-container>
                      <ng-container *ngIf="isLoading">
                        Sending...&nbsp;<i class="fas fa-spinner fa-spin"></i>
                      </ng-container>
                    </button>

                    <button 
                      class="btn hvr-grow has-margin-right" 
                      (click)="$event.preventDefault(); confirmSale(order, order?.platform?.toLowerCase());" 
                      *ngIf="
                        (groups.includes('admin') || groups.includes('operation')) &&
                        (!order?.customSale) && 
                        (
                          (order?.status?.toLowerCase() === 'new') || 
                          (order?.status?.toLowerCase() === 'notaccepted' && order.saleType?.toLowerCase() != 'unique') 
                        )
                      ">
                      CONFERMA
                    </button>
                    <button 
                      class="btn hvr-grow has-margin-right" 
                      (click)="$event.preventDefault(); openInNewTabEdit(order)"
                      *ngIf="(
                        (
                          selected === 'active' &&
                          (groups.includes('admin') || groups.includes('operation')) &&
                          (
                            order?.status?.toLowerCase() === 'new' || 
                            (order?.status?.toLowerCase() === 'notaccepted' && order.saleType?.toLowerCase() !== 'unique')
                          )
                        ) || (
                          selected === 'inactive' &&
                          (groups.includes('admin') || groups.includes('operation')) &&
                          (
                            order?.status?.toLowerCase() === 'confirmed' || 
                            order?.status?.toLowerCase() === 'refused'
                          )
                        )
                      )"
                    >
                      MODIFICA
                    </button>

                    <button 
                      class="btn btn-red hvr-grow has-margin-right" 
                      (click)="$event.preventDefault(); refuseSale(order, order?.platform?.toLowerCase());" 
                      *ngIf="
                        (groups.includes('admin') || groups.includes('operation')) && 
                        (!order?.customSale) && 
                        ((order?.status?.toLowerCase() === 'new') || 
                        (order?.status?.toLowerCase() === 'notaccepted' && order.saleType?.toLowerCase() != 'unique') )
                      ">
                      RIFIUTA
                    </button>

                    <button 
                      class="btn btn-red hvr-grow has-margin-right" 
                      (click)="$event.preventDefault(); refuseSale(order, order?.platform?.toLowerCase());" 
                      *ngIf="(order?.customSale && selected === 'active')">
                      RIFIUTA
                    </button>

                    <button 
                      class="btn btn-red hvr-grow has-margin-right" 
                      (click)="$event.preventDefault(); stopSaleAutomation(order);" 
                      *ngIf="
                        (
                          (groups.includes('admin') || groups.includes('operation')) && 
                          (!order?.customSale) && 
                          (order.status.toLowerCase() === 'emailed') && 
                          (order.saleType?.toLowerCase() === 'nonunique')
                        )" 
                        [disabled]="btnDisable"
                      >
                      INTERROMPI
                    </button>

                    <!--
                    <button 
                      class="btn btn-red hvr-grow has-margin-right" 
                      (click)="$event.preventDefault(); removeDeliveryForUniqueSale(order);" 
                      *ngIf="
                        (
                          (groups.includes('admin') || groups.includes('operation')) && 
                          (!order?.customSale) && 
                          ((order.status.toLowerCase() === 'notaccepted') || (order.status.toLowerCase() === 'notaccepted') && order.saleType?.toLowerCase() === 'unique')
                        )" 
                        [disabled]="btnDisable"
                      >
                      INTERROMPI
                    </button>
                    -->

                    <button
                      class="btn btn-red hvr-grow has-margin-right"
                      (click)="$event.preventDefault(); removeDeliveryForUniqueSale(order);"
                      *ngIf="(groups.includes('admin') || groups.includes('operation'))
                              && !order?.customSale
                              && (order?.status?.toLowerCase() === 'notaccepted' || order?.status?.toLowerCase() === 'emailed')"
                      [disabled]="btnDisable">
                      INTERROMPI
                    </button>

                    <button 
                      class="btn hvr-grow has-margin-right" 
                      (click)="showAiInfo(order)" 
                      *ngIf="
                        showBtnAiBtn(order) && 
                        (!order?.customSale) && 
                        order?.platform?.toLowerCase() === 'cakesales'"
                      >
                      SHOW AI INFO
                    </button>
                </span>
            </div>

          </div>
      </div>
    </section>

  </div>
</section>

<!--
<section class="title-bar content-padding first-item">

  <div class="wrapper nowrap">
    <h2 class="title-heading">{{ settings[selected].title }}</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">

        <button class="btn btn-white vertical align-items-center" routerLink="/custom/sales/nuovo">
          Aggiungi<i class="ml-10 fas fa-plus"></i>
        </button>

        <button class="btn btn-white vertical align-items-center" (click)="export()">
          Esporta<i class="ml-10 fas fa-file-excel"></i>
        </button>

        <button class="btn btn-white vertical align-items-center" routerLink="/sales/payments">
           pagamenti delle vendite <i class="ml-10 fas fa-euro-sign"></i>
        </button>

        <ng-template [ngIf]="selected == 'active'">
          <button class="btn vertical align-items-center" routerLink="/all/vendita/storico">
            Storico<i class="ml-10 far fa-folder"></i>
          </button>
        </ng-template>

        <ng-template [ngIf]="selected == 'inactive'">
          <button class="btn vertical align-items-center" [routerLink]="['../']" [queryParams]="{navigation: 'back'}">
            <i class="ml-10 fas fa-arrow-left has-margin-right"></i>Ritorna a Fatturazione
          </button>
        </ng-template>

      </span>
    </div>
  </div>
</section>
<section class="main-content wrapper content-padding scroll-delivery">
  <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
  <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
      <form  class="table-row-container row first-row filter" [formGroup]="allSaleForm" (ngSubmit)="filter()" *ngIf="allSaleForm">

          <div class="item data-col-5">
            <h4 class="title">PLATFORM</h4>
            <span class="data">
              <select formControlName="platform" style="width: 120px;">
                <option value="">Tutti</option>
                <option value="shopifysale">Deluxy</option>
                <option value="cakesales">Cakes</option>
                <option value="flowerssales">Flowers</option>
                <option value="businesssales">Business</option>
                <option value="deluxyexperiencesales">Deluxy Experience</option>
                <option value="deluxydotcomsales">Deluxy Dot Com</option>
              </select>
            </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('id')">
                <i class="sort-icon fas" [ngClass]="orderIcon('id')"></i>
                SYSTEM ID
              </h4>
              <span class="data">
                <input type="number" min="1000" max="10000" formControlName="id">
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('actualOrderId')">
                <i class="sort-icon fas" [ngClass]="orderIcon('actualOrderId')"></i>
                ID ordine effettivo
              </h4>
              <span class="data">
                <input type="number" min="1000" max="10000" formControlName="actualOrderId">
              </span>
          </div>

          <div class="item data-col-5">
              <h4 class="title" (click)="navigateOrder('orderId')"> 
                <i class="sort-icon fas" [ngClass]="orderIcon('orderId')"></i>
                Ordine
              </h4>
              <span class="data">
                <input type="number" min="1000" max="10000" formControlName="orderId">
              </span>
          </div>

          <div class="item data-col-5" *ngIf="selected != 'active'">
            <h4 class="title">Conferma tipo</h4>
            <span class="data">
              <select formControlName="confirmedBy" style="width: 120px;">
                <option value="">Tutti</option>
                <option value="Partner">Automatic</option>
                <option value="Admin">Admin</option>
              </select>
            </span>
          </div>

          <div class="item data-col-10 item" *ngIf="selected == 'inactive'">
            <h4 class="title" (click)="navigateOrder('deliveryDate')">
              <i class="sort-icon fas" [ngClass]="orderIcon('deliveryDate')"></i>
              ORDINE DATA
            </h4>
            <span class="data">
              <div class="date">Da:</div>
              <input class="date" type="date" formControlName="deliveryDate_from">
            </span>
            <span class="data">
              <div class="date">A: </div>
              <input class="date" type="date" formControlName="deliveryDate_to">
            </span>
          </div>

          <div class="item data-col-10 item">
            <h4 class="title" (click)="navigateOrder('deliveryDate')">
              <i class="sort-icon fas" [ngClass]="orderIcon('deliveryDate')"></i>
              DATA
            </h4>
            <span class="data">
              <div class="date">Da:</div>
              <input class="date" type="date" formControlName="deliveryDate_from">
            </span>
            <span class="data">
              <div class="date">A: </div>
              <input class="date" type="date" formControlName="deliveryDate_to">
            </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('orderId')">
                <i class="sort-icon fas" [ngClass]="orderIcon('orderId')"></i>
                Cliente
              </h4>
              <span class="data">
                <input type="text" formControlName="orderId">  
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('address')">
                <i class="sort-icon fas" [ngClass]="orderIcon('address')"></i>
                Indirizzo
              </h4>
              <span class="data">
                <input type="text" formControlName="address">  
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('phone')">
                <i class="sort-icon fas" [ngClass]="orderIcon('phone')"></i>
                Telefono
              </h4>
              <span class="data">
                <input type="text" formControlName="phone">  
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('channel')">
                <i class="sort-icon fas" [ngClass]="orderIcon('channel')"></i>
                Canale
              </h4>
              <span class="data">
                <input type="text" formControlName="channel">  
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('total')">
                <i class="sort-icon fas" [ngClass]="orderIcon('total')"></i>
                Totale
              </h4>
              <span class="data">
                <input type="text" formControlName="total">  
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('total')">
                <i class="sort-icon fas" [ngClass]="orderIcon('total')"></i>
                COSTO CONSEGNA
              </h4>
              <span class="data">
                <input type="text" formControlName="totalDeliveryCost">  
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('paymentStatus')">
                <i class="sort-icon fas" [ngClass]="orderIcon('paymentStatus')"></i>
                Stato del pagamento
              </h4>
              <span class="data">
                <input type="text" formControlName="paymentStatus">  
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('fullFillmentStatus')">
                <i class="sort-icon fas" [ngClass]="orderIcon('fullFillmentStatus')"></i>
                Stato di adempimento
              </h4>
              <span class="data">
                <input type="text" formControlName="fullFillmentStatus">  
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('orderId')">
                <i class="sort-icon fas" [ngClass]="orderIcon('orderId')"></i>
                Elementi
              </h4>
              <span class="data">
                <input type="text" formControlName="orderId">  
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('orderId')">
                <i class="sort-icon fas" [ngClass]="orderIcon('orderId')"></i>
                SKU
              </h4>
              <span class="data">
                <input type="text" formControlName="orderId">
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('deliveryMethod')">
                <i class="sort-icon fas" [ngClass]="orderIcon('deliveryMethod')"></i>
                metodo di consegna
              </h4>
              <span class="data">
                <input type="text" formControlName="deliveryMethod">  
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('vendor')">
                <i class="sort-icon fas" [ngClass]="orderIcon('vendor')"></i>
                Vendor
              </h4>
              <span class="data">
                <input type="text" formControlName="vendor">
              </span>
          </div>

          <div class="item data-col-10">
              <h4 class="title" (click)="navigateOrder('status')">
                <i class="sort-icon fas" [ngClass]="orderIcon('status')"></i>
                Stato
              </h4>
              <span class="data">
                <input type="text" formControlName="status">  
              </span>
          </div>

          <div class="item nowrap">
            <h4 class="title hide-on-mobile">AZIONI</h4>
            <span class="data-row-left btn-container btn-container-actions">
              <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                RICERCA <i class="fas fa-search"></i></button>
                <br/>
              <button class="btn vertical align-items-center" (click)="resetFilter();">
                RESET <i class="fas fa-times-circle"></i></button>
            </span>
          </div>
      </form>

      <div class="table-row-container row" *ngFor="let order of orders">

        <div class="item data-col-5">
          <h4 class="title">
            PLATFORM
          </h4>
          <div class="data data-id">
            <div>
              <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                {{
                  order?.platform?.toLowerCase() === 'businesssales' ? "BUSINESS" :
                  order?.platform?.toLowerCase() === 'shopifysale' ? "DELUXY" :
                  order?.platform?.toLowerCase() === 'flowerssales' ? "FLOWERS" :
                  order?.platform?.toLowerCase() === 'customsale' ? "CUSTOMSALE" :
                  order?.platform?.toLowerCase() === 'cakesales' ? "CAKE" : 
                  order?.platform?.toLowerCase() === 'deluxyexperiencesales' ? "DELUXY EXPERIENCE" :
                  order?.platform?.toLowerCase() === 'deluxydotcomsales' ? "DELUXY DOT COM" :
                  "---"
                }}
              </a>
            </div>
          </div>
        </div>

        <div class="item data-col-10">
            <h4 class="title">
              SYSTEM ID :
            </h4>
            <div class="data data-id">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  #{{ order.id || "---" }}
                </a>
              </div>
            </div>
        </div>

        <div class="item data-col-10">
            <h4 class="title">
              ID ordine effettivo :
            </h4>
            <div class="data data-id">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ order.actualOrderId ? "#"+order.actualOrderId : "---" }}
                </a>
              </div>
            </div>
        </div>

        <div class="item data-col-5">
            <h4 class="title">
              Ordine
            </h4>
            <div class="data data-id">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ order.orderId ? "#"+order.orderId : "---" }}
                </a>
              </div>
            </div>
        </div>

        <div class="item data-col-10" *ngIf="selected != 'active'">
            <h4 class="title">
              Conferma tipo
            </h4>
            <div class="data data-id">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale" *ngIf="selected == 'inactive'">
                  {{ showWhoConfirm(order) }}
                </a>
              </div>
            </div>
        </div>

        <div class="item data-col-10" *ngIf="selected == 'inactive'">
            <h4 class="title">
              ORDINE DATA :
            </h4>
            <div class="data">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ order.createdAt | date:'MMMM d, y' }}
                </a>
              </div>
            </div>
        </div>

        <div class="item data-col-10">
            <h4 class="title">
              Data :
            </h4>
            <div class="data">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ order.deliveryDate && isValidDate(order.deliveryDate) ? (order.deliveryDate | date:'MMMM d, y') : 'N/A' }} 
                  {{ order.deliveryTime ? ' ' + order.deliveryTime : '' }}
                </a>
              </div>
            </div>
        </div>

        <div class="item data-col-5">
            <h4 class="title">
              Cliente :
            </h4>
            <div class="data">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ ( (order.firstName || '-')  + ' ' + (order.lastName || '-')) }}
                </a>
              </div>
            </div>
        </div>
        
        <div class="item data-col-5">
            <h4 class="title">
              Indirizzo
            </h4>
            <div class="data">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ ( order.address || "---") }}
                </a>
              </div>
            </div>
        </div>
        
        <div class="item data-col-5">
            <h4 class="title">
              Telefono
            </h4>
            <div class="data">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ ( order.phone || "---") }}
                </a>
              </div>
            </div>
        </div>
        
        <div class="item data-col-5">
            <h4 class="title">
              Canale
            </h4>
            <div class="data">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ ( order.channel || "---") }}
                </a>
              </div>
            </div>
        </div>
        
        <div class="item data-col-5">
            <h4 class="title">
              Totale
            </h4>
            <div class="data">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ ( order.total || "---") }}
                </a>
              </div>
            </div>
        </div>
        
        <div class="item data-col-5">
            <h4 class="title">
              COSTO CONSEGNA
            </h4>
            <div class="data">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ showDeliveryPrice(order) | currency:'EUR' }}
                </a>
              </div>
            </div>
        </div>
        
        <div class="item data-col-5">
            <h4 class="title">
              Stato del pagamento
            </h4>
            <div class="data">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ ( order.paymentStatus || "---") }}
                </a>
              </div>
            </div>
        </div>
        
        <div class="item data-col-5">
            <h4 class="title">
              Stato di adempimento
            </h4>
            <div class="data">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ order.fullFillmentStatus || "Unfullfilled" }}
                </a>
              </div>
            </div>
        </div>
        
        <div class="item data-col-5">
            <h4 class="title">
              Elementi
            </h4>
            <div class="data">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ myjson.parse(order.lineItems) | arrayJoin:', ':'name' }}
                </a>
              </div>
            </div>
        </div>

        <div class="item data-col-5">
            <h4 class="title">
              SKU
            </h4>
            <div class="data">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ myjson.parse(order.lineItems) | arrayJoin:', ':'sku' }}
                </a>
              </div>
            </div>
        </div>
        
        <div class="item data-col-5">
            <h4 class="title">
              metodo di consegna
            </h4>
            <div class="data">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ order.deliveryMethod || "---" }}
                </a>
              </div>
            </div>
        </div>
        
        <div class="item data-col-5">
            <h4 class="title">
              Vendor
            </h4>
            <div class="data">
              <div>
                <a (click)="$event.preventDefault(); openInNewTab(order.id, order)" class="redirect-sale">
                  {{ order.vendor || "---" }}
                </a>
              </div>
            </div>
        </div>
        
        <div class="item data-col-5">
          <h4 class="title">Stato</h4>

          <a
            (click)="$event.preventDefault(); openInNewTab(order.id, order)"
            class="redirect-sale"
          >
            {{ getOrderLabel(order, selected) }}
          </a>
        </div>

        <div class="item nowrap">
            <span class="data-row-left btn-container btn-container-actions">
                <button class="btn hvr-grow has-margin-right" (click)="$event.preventDefault(); generateLink(order);">
                  <ng-container *ngIf="!isLoading">
                    Generate Link&nbsp;<i class="ml-10 fas fa-link"></i>
                  </ng-container>
                  <ng-container *ngIf="isLoading">
                    Generating...&nbsp;<i class="fas fa-spinner fa-spin"></i>
                  </ng-container>
                </button>

                <button class="btn hvr-grow has-margin-right" (click)="$event.preventDefault(); sendEmailToCustomer(order)">
                  <ng-container *ngIf="!isLoading">
                    Send Email&nbsp;<i class="ml-10 fas fa-link"></i>
                  </ng-container>
                  <ng-container *ngIf="isLoading">
                    Sending...&nbsp;<i class="fas fa-spinner fa-spin"></i>
                  </ng-container>
                </button>

                <button 
                  class="btn hvr-grow has-margin-right" 
                  (click)="$event.preventDefault(); confirmSale(order, order?.platform?.toLowerCase());" 
                  *ngIf="
                    (groups.includes('admin') || groups.includes('operation')) &&
                    (!order?.customSale) && 
                    (
                      (order?.status?.toLowerCase() === 'new') || 
                      (order?.status?.toLowerCase() === 'notaccepted' && order.saleType?.toLowerCase() != 'unique') 
                    )
                  ">
                  CONFERMA
                </button>
                <button 
                  class="btn hvr-grow has-margin-right" 
                  (click)="$event.preventDefault(); openInNewTabEdit(order)"
                  *ngIf="(
                    (
                      selected === 'active' &&
                      (groups.includes('admin') || groups.includes('operation')) &&
                      (
                        order?.status?.toLowerCase() === 'new' || 
                        (order?.status?.toLowerCase() === 'notaccepted' && order.saleType?.toLowerCase() !== 'unique')
                      )
                    ) || (
                      selected === 'inactive' &&
                      (groups.includes('admin') || groups.includes('operation')) &&
                      (
                        order?.status?.toLowerCase() === 'confirmed' || 
                        order?.status?.toLowerCase() === 'refused'
                      )
                    )
                  )"
                >
                  MODIFICA
                </button>

                <button 
                  class="btn btn-red hvr-grow has-margin-right" 
                  (click)="$event.preventDefault(); refuseSale(order, order?.platform?.toLowerCase());" 
                  *ngIf="
                    (groups.includes('admin') || groups.includes('operation')) && 
                    (!order?.customSale) && 
                    ((order?.status?.toLowerCase() === 'new') || 
                    (order?.status?.toLowerCase() === 'notaccepted' && order.saleType?.toLowerCase() != 'unique') )
                  ">
                  RIFIUTA
                </button>

                <button 
                  class="btn btn-red hvr-grow has-margin-right" 
                  (click)="$event.preventDefault(); refuseSale(order, order?.platform?.toLowerCase());" 
                  *ngIf="(order?.customSale && selected === 'active')">
                  RIFIUTA
                </button>

                <button 
                  class="btn btn-red hvr-grow has-margin-right" 
                  (click)="$event.preventDefault(); stopSaleAutomation(order);" 
                  *ngIf="
                    (
                      (groups.includes('admin') || groups.includes('operation')) && 
                      (!order?.customSale) && 
                      (order.status.toLowerCase() === 'emailed') && 
                      (order.saleType?.toLowerCase() === 'nonunique')
                    )" 
                    [disabled]="btnDisable"
                  >
                  INTERROMPI
                </button>

                <button
                  class="btn btn-red hvr-grow has-margin-right"
                  (click)="$event.preventDefault(); removeDeliveryForUniqueSale(order);"
                  *ngIf="(groups.includes('admin') || groups.includes('operation'))
                          && !order?.customSale
                          && (order?.status?.toLowerCase() === 'notaccepted' || order?.status?.toLowerCase() === 'emailed')"
                  [disabled]="btnDisable">
                  INTERROMPI
                </button>

                <button 
                  class="btn hvr-grow has-margin-right" 
                  (click)="showAiInfo(order)" 
                  *ngIf="
                    showBtnAiBtn(order) && 
                    (!order?.customSale) && 
                    order?.platform?.toLowerCase() === 'cakesales'"
                  >
                  SHOW AI INFO
                </button>
            </span>
        </div>

      </div>
  </div>
</section>
-->